import { render } from "./DesktopBarLink.vue?vue&type=template&id=14d6f460&scoped=true&ts=true"
import script from "./DesktopBarLink.vue?vue&type=script&lang=ts"
export * from "./DesktopBarLink.vue?vue&type=script&lang=ts"

import "./DesktopBarLink.vue?vue&type=style&index=0&id=14d6f460&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d6f460"]])

export default __exports__